/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentCreateResponse
 */
export interface IncidentCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof IncidentCreateResponse
     */
    id: string;
}

/**
 * Check if a given object implements the IncidentCreateResponse interface.
 */
export function instanceOfIncidentCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function IncidentCreateResponseFromJSON(json: any): IncidentCreateResponse {
    return IncidentCreateResponseFromJSONTyped(json, false);
}

export function IncidentCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function IncidentCreateResponseToJSON(value?: IncidentCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

